import { render, staticRenderFns } from "./numField.vue?vue&type=template&id=387c4dc0&scoped=true&"
import script from "./numField.vue?vue&type=script&lang=js&"
export * from "./numField.vue?vue&type=script&lang=js&"
import style0 from "./numField.vue?vue&type=style&index=0&id=387c4dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c4dc0",
  null
  
)

export default component.exports